import React from 'react';
import PropTypes from 'prop-types';
// import classnames from 'classnames';
import { Wrapper, Divider } from 'components/Ui';

import styles from './styles.scss';

const SubtotalBlock = ({ summary: { subtotal } }) => (
  <Wrapper className={styles.subTotalContainer}>
    <div className={styles.row}>
      <div className={styles.boldText}>Subtotal Installation Fee</div>
      <div className={styles.priceText}>${subtotal}</div>
    </div>
    <Divider className={styles.divider} />
    {/* <div className={classnames(styles.row, styles.marginBtm)}>
      <div className={styles.boldText}>Delivery Fee</div>
      <div className={styles.priceText}>$39.99</div>
    </div> */}
    <div className={styles.row}>
      <div className={styles.boldText}>Estimated Tax</div>
      <div className={styles.priceText}>TBD</div>
    </div>
  </Wrapper>
);

SubtotalBlock.propTypes = {
  summary: PropTypes.shape({
    subtotal: PropTypes.number,
  }),
};

export default SubtotalBlock;
